import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({ root: { color: theme.red500 } }),
);

export function RequiredFieldLabel({ text }: { text: string }) {
  const classes = useStyles();

  return (
    <>
      {text}
      <span className={classes.root}>*</span>
    </>
  );
}
